import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools } from '../../services'

import Switch from 'react-switch'
import { Headerbar, FormInput, Table, ConfirmButton, Loader, EditContainer, ImagesPicker, Select } from '../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

const opts = [
  { value: 'percentage', label: "Pourcentage (%)" },
  { value: 'absolute', label: 'Réduction fixe (€)' },
]

interface Props {
  promo: any;
  elementId: string;
  saving: boolean;
  changed: boolean;

  onChange: (tickets: any[]) => void;
  onSave: () => void;
}
const TicketingPromoGrid: React.FC<Props> = (props) => {

  const promo = props.promo || {}
  const [error, setError] = React.useState('')
  const elementId = props.elementId
  const elementRef = Fire.collection('ads').doc(elementId)
  const [tickets, setTickets] = React.useState<any[]>(promo.tickets || [])
  const [ticket, setTicket] = React.useState<any>(null)

  React.useEffect(() => {
    fetchTickets()
  }, [])

  React.useEffect(() => {
    setTickets(promo.tickets)
  }, [promo])

  const fetchTickets = async () => {
    try {
      const ref = elementRef.collection('tickets').orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)

      const notExisting: any[] = []
      for (const ticket of list) {
        let exist = false
        for (const promoTicket of tickets) {
          if (ticket.id === promoTicket.id) {
            exist = true
            break
          }
        }
        if (!exist)
          notExisting.push(ticket)
      }
      setTickets(tickets.concat(notExisting))
    } catch (err) {
      setError("Impossible de charger les tickets")
      console.warn(err)
    }
  }

  const onSave = async () => {
    const savableTickets: any[] = []
    for (const t of tickets) {
      if (t.id == ticket.id) {
        savableTickets.push({
          ...t,
          promo_amount: Number(ticket.promo_amount || 0),
          promo_type: ticket.promo_type || 'percentage',
        })
      }
      else
        savableTickets.push(t)
    }
    props.onChange(savableTickets)
    setTicket(null)
    setTickets(savableTickets)
  }

  const onChangeTicket = (key: string, value: any) => {
    const add: any = {}
    add[key] = value
    setTicket({ ...ticket, ...add })
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Grille tarifaire</h3>
      </div>
      <div className="card-body">
        
        { ticket &&
          <div>
            <div style={{marginTop: 10, marginBottom: 10}} className="title">Choisir le type de réduction</div>
            <div style={{marginBottom: 20}}>
              <Select
                value={ticket.promo_type}
                onChange={(val: string) => onChangeTicket('promo_type', val)}
                options={opts}
              />
            </div>

            <FormInput
              type="number"
              placeholder={(ticket.promo_type === 'percentage' ? "Pourcentage" : "Réduction") + " du code promo"}
              value={ticket.promo_amount}
              onChange={(evt: any) => onChangeTicket('promo_amount', evt.target.value)}
              />

            <ConfirmButton
              title={'Sauvegarder'}
              noConfirm
              confirmTitle={''}
              onPress={(e) => {
                e.stopPropagation();
                onSave()
              }} />
          </div>
        }

        <Table
          data={tickets.map((item) => ({
            ...item,
            type_col: (item.promo_type === 'percentage' ? 'Pourcentage' : 'Absolu') || '-',
            amount_col: item.promo_amount || 0,
          }))}
          columns={[
            { name: 'Ticket', string: 'name', sortable: true, accessor: 'name' },
            { name: 'Type', string: 'type_col', sortable: true, accessor: 'type_col' },
            { name: 'Value', accessor: 'amount_col' },
            { name: 'Actions', accessor: 'actions', hasButton: true, cell: (item) => (
                <div>
                  <ConfirmButton
                    title={'Modifier'}
                    noConfirm
                    confirmTitle={''}
                    onPress={(e) => {
                      e.stopPropagation();
                      setTicket(item)
                    }} />
                </div>
              )},
          ]}
          />

          <div className="centered">
            <button
              type="button"
              className="btn btn-outline-primary"
              disabled={props.saving || !props.changed}
              onClick={props.onSave}
              >
              { props.saving ? 'Chargement...' : 'Enregistrer' }
            </button>
          </div>
      </div>
    </div>
  );
}

export default TicketingPromoGrid
